import styled from "styled-components";

export const Container = styled.div`
	border: 2px solid antiquewhite;
	max-width: 350px;
	min-block-size: 150px;
	padding-bottom: 10px;
	margin: auto;
	background-color: antiquewhite;
	text-align: center;
`;
